import { LoadableLazy } from '@confluence/loadable';
export { isEligibleForReleaseNotesDiscovery } from '../src/rovo/ReleaseNotesDialog.tsx';
export const LazyReleaseNotesPublishDiscoveryDialog = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReleaseNotesDialog" */ '../src/rovo/ReleaseNotesDialog.tsx'
			)
		).ReleaseNotesDialog,
});
